import { IconButton, Tooltip } from "@mui/material";
import moment from "moment/moment";
import React, { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { axiosGet } from "../../../utils/AxiosApi";
import { URL } from "../../../utils/Constants";
import ModalWindow from "../../UI/ModalWindow";
import ViewSubmittedForm from "./ViewSubmittedForm";

const tableStyles = {
  headCells: {
    style: {
      fontWeight: 600,
      fontSize: "13px",
      textTransform: "uppercase",
      color: "#000000de",
      background: "#fff",
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  rows: {
    style: {
      fontSize: "12px",
      "&:hover": { background: "#f8fafc" },
    },
  },
  cells: {
    style: { paddingTop: 8, paddingBottom: 8 },
  },
};

const ListSubmittedForm = () => {
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const getAllResponses = useCallback(() => {
    setLoading(true);
    axiosGet(URL.getAllResponses, (response) => {
      if (response.status === 200) {
        setForms(response.data.data);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    getAllResponses();
  }, [getAllResponses]);

  const selectForm = (form) => {
    const normalizedAnswerOptions =
      form?.answers?.map((a) => {
        let parsedOptions = a.options;
        let parsedValue = a.textValue;
        if (typeof a.options === "string") {
          try {
            parsedOptions = JSON.parse(a.options);
            parsedValue = JSON.parse(a.textValue);
          } catch (e) {
            parsedOptions = [];
          }
        }
        return {
          ...a,
          options: parsedOptions ?? [],
          textValue: parsedValue ?? "",
        };
      }) || [];
    setSelectedResponse({ ...form, answers: normalizedAnswerOptions });
    setShowPreview(true);
  };

  const columns = [
    {
      name: "Form Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Submitted At",
      selector: (row) =>
        moment(row.submittedAt).format("YYYY-MM-DD HH:mm") || "-",
      sortable: true,
    },
    {
      name: "Submitted By",
      selector: (row) => row.submittedByName || "-",
      sortable: true,
    },
    {
      name: "Evaluated To",
      selector: (row) => row.evaluationTo || "-",
      sortable: true,
    },
    {
      name: "Subject",
      selector: (row) => row.evaluationSubjectName || "-",
    },
    {
      name: "Points",
      selector: (row) =>
        row.obtainedPoints ? row.obtainedPoints.toFixed(1) + "/5" : "-",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <Tooltip title="View">
          <div>
            <IconButton onClick={() => selectForm(row)}>
              <span className="material-icons-round actionIcon AddColor">
                visibility
              </span>
            </IconButton>
          </div>
        </Tooltip>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  return (
    <div className="arr-content">
      <div className="arr-heading">
        <h1>Submitted Forms</h1>
      </div>
      <div
        className="arr-table-container"
        style={{
          width: "1200px",
          minWidth: "100%",
          maxWidth: "100%",
        }}
      >
        <DataTable
          dense
          columns={columns}
          data={forms}
          progressPending={loading}
          progressComponent={
            <div style={{ padding: 32, color: "#94a3b8", fontSize: 13 }}>
              Loading...
            </div>
          }
          noDataComponent={
            <div style={{ padding: 32, color: "#94a3b8", fontSize: 13 }}>
              No records found for this grouping.
            </div>
          }
          highlightOnHover
          striped
          responsive
          customStyles={tableStyles}
        />
      </div>

      <ModalWindow
        modal={showPreview}
        size="lg"
        id="tt-viewModal"
        toggleModal={() => setShowPreview(false)}
        modalHeader="View Submitted Response"
        modalBody={<ViewSubmittedForm selectedResponse={selectedResponse} />}
      />
    </div>
  );
};

export default ListSubmittedForm;
